/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-04 12:29:24
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 19:11:48
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SiderErrorController/slice/index.ts
 */
import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import {
  checkSalesChannelSiderErr,
  checkSalesChannelProductSiderErr,
  checkSalesChannelContentSiderErr,
} from 'src/request/common';
import { getStateTarget as getTarget } from 'src/tools/helper';
import { EnumReducers } from 'src/store/constants';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

//import { assData } from 'src/tools/helper';

const siderErrReducers = (reducers = []) => {
  return [EnumReducers.siderErrorSet, ...reducers];
};
const reducerTarget = (state, reducers = []) => {
  return getTarget(state, siderErrReducers(reducers));
};

export const fetchSalesChannelSiderError = createAsyncThunk(
  'fetchSalesChannelSiderError',
  async (body: any) => {
    const { salesChannelUuid } = body;
    const response = await checkSalesChannelSiderErr({ salesChannelUuid });
    return { uuid: salesChannelUuid, response };
  },
);

export const fetchSalesChannelContentSiderError = createAsyncThunk(
  'fetchSalesChannelContentSiderError',
  async (body: any) => {
    const { salesChannelUuid, contentUuid } = body;
    const response = await checkSalesChannelContentSiderErr(
      {
        salesChannelUuid,
        contentUuid,
      },
      { [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true },
    );
    return { uuid: contentUuid, response };
  },
);

export const fetchSalesChannelProductSiderError = createAsyncThunk(
  'fetchSalesChannelProductSiderError',
  async (body: any) => {
    const { salesChannelUuid, productUuid } = body;
    const response = await checkSalesChannelProductSiderErr(
      {
        salesChannelUuid,
        productUuid,
      },
      { [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true },
    );
    return { uuid: productUuid, response };
  },
);

const defaultState = {};

const siderErrorController = createSlice({
  name: 'siderErrorController',
  initialState: defaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSalesChannelSiderError.fulfilled, (state, action) => {
      const { response, uuid } = action.payload;
      state[uuid] = response || {};
    });
    builder.addCase(
      fetchSalesChannelContentSiderError.fulfilled,
      (state, action) => {
        const { response, uuid } = action.payload;
        state[uuid] = response || {};
      },
    );
    builder.addCase(
      fetchSalesChannelProductSiderError.fulfilled,
      (state, action) => {
        const { response, uuid } = action.payload;
        state[uuid] = response || {};
      },
    );
  },
});

const getErrorState = (id) => {
  return createSelector(
    (state: any) => {
      return reducerTarget(state, id);
    },
    (error) => {
      return error;
    },
  );
};

export { getErrorState };
export default siderErrorController.reducer;
